import { jsx as _jsx } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgTooltipInfo = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    d: "M11.999 15.959a.64.64 0 0 0 .466-.2.63.63 0 0 0 .2-.46v-3.493a.6.6 0 0 0-.2-.445.65.65 0 0 0-.933.007.63.63 0 0 0-.2.459v3.493q0 .252.2.445a.65.65 0 0 0 .467.194m0-6.239q.285 0 .5-.214a.69.69 0 0 0 .214-.5.69.69 0 0 0-.214-.5.69.69 0 0 0-.5-.215.69.69 0 0 0-.5.214.69.69 0 0 0-.215.5q0 .287.214.5.215.215.5.215m0 10.197a7.8 7.8 0 0 1-3.094-.62 8 8 0 0 1-2.514-1.689 8 8 0 0 1-1.689-2.514 7.8 7.8 0 0 1-.62-3.093q0-1.65.62-3.094a8 8 0 0 1 1.69-2.514 8 8 0 0 1 2.513-1.689 7.8 7.8 0 0 1 3.094-.62q1.648 0 3.093.62a8 8 0 0 1 2.514 1.69 8 8 0 0 1 1.69 2.513q.62 1.444.62 3.094t-.62 3.093a8 8 0 0 1-1.69 2.514 8 8 0 0 1-2.514 1.69 7.8 7.8 0 0 1-3.093.62m-.005-1.333q2.733 0 4.66-1.922 1.929-1.923 1.928-4.656 0-2.735-1.922-4.662t-4.656-1.927T7.342 7.34t-1.927 4.657 1.922 4.66 4.657 1.928"
  })
});
export default SvgTooltipInfo;